import { render, staticRenderFns } from "./ProfileV2.vue?vue&type=template&id=22fa33f7&scoped=true"
import script from "./ProfileV2.vue?vue&type=script&lang=js"
export * from "./ProfileV2.vue?vue&type=script&lang=js"
import style0 from "./ProfileV2.vue?vue&type=style&index=0&id=22fa33f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fa33f7",
  null
  
)

export default component.exports